import { formatInTimeZone } from 'date-fns-tz'

export const formatTimeForRequest = (time: Date | null | undefined): string => {
  return time ? formatInTimeZone(time, 'UTC', 'yyyy-MM-dd HH:mm') : ''
}
